export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7210.667f3db0.jpg";